var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "a74aecd5-b1cd-4571-b457-8f39b2457d20"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "d28b9181-f095-4a76-9576-d6bbdfa74fa1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 9.75 -5.38)",
    id: "Vector 739"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(106,177,51)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-29.97, -13.93)",
    d: "M 20.4351 9.38782 C 20.2169 9.38782 20.0401 9.56466 20.0401 9.78281 C 20.0401 10.001 20.2169 10.1778 20.4351 10.1778 L 20.4351 9.38782 Z M 20.4351 6.22789 C 20.2169 6.22789 20.0401 6.40473 20.0401 6.62288 C 20.0401 6.84103 20.2169 7.01787 20.4351 7.01787 L 20.4351 6.22789 Z M 35.8397 24.0025 L 38.7105 24.0025 L 38.7105 23.2125 L 35.8397 23.2125 L 35.8397 24.0025 Z M 39.8955 22.8175 L 39.8955 8.99283 L 39.1055 8.99283 L 39.1055 22.8175 L 39.8955 22.8175 Z M 38.7105 7.80785 L 31.8898 7.80785 L 31.8898 8.59784 L 38.7105 8.59784 L 38.7105 7.80785 Z M 32.2848 8.20284 L 32.2848 6.22789 L 31.4948 6.22789 L 31.4948 8.20284 L 32.2848 8.20284 Z M 31.0998 5.04291 L 25.9649 5.04291 L 25.9649 5.8329 L 31.0998 5.8329 L 31.0998 5.04291 Z M 25.5699 5.4379 L 25.5699 10.9678 L 26.3599 10.9678 L 26.3599 5.4379 L 25.5699 5.4379 Z M 25.9649 11.3628 L 31.0998 11.3628 L 31.0998 10.5728 L 25.9649 10.5728 L 25.9649 11.3628 Z M 32.2848 10.1778 L 32.2848 8.20284 L 31.4948 8.20284 L 31.4948 10.1778 L 32.2848 10.1778 Z M 26.3599 5.4379 L 26.3599 5.04291 L 25.5699 5.04291 L 25.5699 5.4379 L 26.3599 5.4379 Z M 26.3599 11.3628 L 26.3599 10.9678 L 25.5699 10.9678 L 25.5699 11.3628 L 26.3599 11.3628 Z M 23.99 10.5728 L 23.99 11.3628 L 24.78 11.3628 L 24.78 10.5728 L 23.99 10.5728 Z M 23.99 9.78281 L 23.99 10.5728 L 24.78 10.5728 L 24.78 9.78281 L 23.99 9.78281 Z M 20.4351 10.1778 L 24.385 10.1778 L 24.385 9.38782 L 20.4351 9.38782 L 20.4351 10.1778 Z M 23.99 5.04291 L 23.99 5.8329 L 24.78 5.8329 L 24.78 5.04291 L 23.99 5.04291 Z M 23.99 5.8329 L 23.99 6.62288 L 24.78 6.62288 L 24.78 5.8329 L 23.99 5.8329 Z M 23.99 6.62288 L 23.99 9.78281 L 24.78 9.78281 L 24.78 6.62288 L 23.99 6.62288 Z M 24.385 6.22789 L 20.4351 6.22789 L 20.4351 7.01787 L 24.385 7.01787 L 24.385 6.22789 Z M 25.5699 11.3628 C 25.5699 11.5809 25.3931 11.7578 25.175 11.7578 L 25.175 12.5477 C 25.8294 12.5477 26.3599 12.0172 26.3599 11.3628 L 25.5699 11.3628 Z M 23.99 11.3628 C 23.99 12.0172 24.5205 12.5477 25.175 12.5477 L 25.175 11.7578 C 24.9568 11.7578 24.78 11.5809 24.78 11.3628 L 23.99 11.3628 Z M 25.175 3.85794 C 24.5205 3.85794 23.99 4.38847 23.99 5.04291 L 24.78 5.04291 C 24.78 4.82476 24.9568 4.64792 25.175 4.64792 L 25.175 3.85794 Z M 26.3599 5.04291 C 26.3599 4.38847 25.8294 3.85794 25.175 3.85794 L 25.175 4.64792 C 25.3931 4.64792 25.5699 4.82476 25.5699 5.04291 L 26.3599 5.04291 Z M 32.2848 6.22789 C 32.2848 5.57344 31.7543 5.04291 31.0998 5.04291 L 31.0998 5.8329 C 31.318 5.8329 31.4948 6.00974 31.4948 6.22789 L 32.2848 6.22789 Z M 31.0998 11.3628 C 31.7543 11.3628 32.2848 10.8322 32.2848 10.1778 L 31.4948 10.1778 C 31.4948 10.3959 31.318 10.5728 31.0998 10.5728 L 31.0998 11.3628 Z M 39.8955 8.99283 C 39.8955 8.33838 39.3649 7.80785 38.7105 7.80785 L 38.7105 8.59784 C 38.9287 8.59784 39.1055 8.77468 39.1055 8.99283 L 39.8955 8.99283 Z M 38.7105 24.0025 C 39.365 24.0025 39.8955 23.472 39.8955 22.8175 L 39.1055 22.8175 C 39.1055 23.0357 38.9287 23.2125 38.7105 23.2125 L 38.7105 24.0025 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -8.65 1.22)",
    id: "Vector 736"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.789983,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(106,177,51)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-11.57, -20.53)",
    d: "M 13.884 27.4761 C 13.1983 26.2762 11.9299 23.1566 12.3412 20.2768 C 12.6518 18.1032 13.1772 15.9881 13.5636 14.6393 C 13.7121 14.121 13.3271 13.5918 12.7879 13.5918 L 11.3679 13.5918 C 11.0279 13.5918 10.726 13.8094 10.6185 14.132 L 9.25586 18.2199",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 4.22 5.08)",
    id: "Vector 735"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.789983,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(106,177,51)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-24.44, -24.39)",
    d: "M 12.3418 30.0475 L 14.913 30.0475 M 14.913 30.0475 L 35.7686 30.0475 C 36.1858 30.0475 36.5321 29.7242 36.5299 29.3071 C 36.5143 26.4263 35.5849 21.8198 34.4539 21.8198 C 33.2197 21.8198 30.5114 21.8198 29.3115 21.8198 C 31.1465 21.8198 34.267 21.8198 35.7212 21.8198 C 36.1575 21.8198 36.5108 21.4666 36.5108 21.0304 C 36.5108 20.5832 36.5108 20.0164 36.5108 19.524 C 36.5108 19.0877 36.1571 18.7344 35.7208 18.7344 L 21.8738 18.7344 C 21.4375 18.7344 21.0838 19.0881 21.0838 19.5244 L 21.0838 21.8198 M 14.913 30.0475 L 14.3178 28.5597 C 14.1103 28.0408 14.4924 27.4764 15.0513 27.4764 L 20.2938 27.4764 C 20.7301 27.4764 21.0838 27.1227 21.0838 26.6864 L 21.0838 21.8198 M 27.7688 21.8198 L 21.0838 21.8198",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -12.33 3.13)",
    id: "Vector 737"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.789983,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(106,177,51)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-7.89, -22.45)",
    d: "M 7.19922 24.6287 L 8.58555 20.2617",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -7.62 -7.35)",
    id: "Vector 738"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.789983,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(106,177,51)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-12.6, -11.97)",
    d: "M 13.885 13.5918 L 9.53266 13.5918 C 9.09636 13.5918 8.74268 13.2381 8.74268 12.8018 L 8.74268 11.1321 C 8.74268 10.5806 9.29359 10.1988 9.81004 10.3924 L 12.7221 11.4845 M 13.885 13.5918 L 15.6662 13.5918 C 16.1025 13.5918 16.4562 13.2381 16.4562 12.8018 L 16.4562 12.3249 C 16.4562 11.8886 16.1025 11.5349 15.6662 11.5349 L 12.9998 11.5349 C 12.9051 11.5349 12.8108 11.5177 12.7221 11.4845 L 12.7221 11.4845 M 13.885 13.5918 C 13.4526 13.2154 12.6145 12.2669 12.7221 11.4845",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -13.21 12.8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 1.57997,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(106,177,51)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-7.01, -32.11)",
    d: "M 11.7459 29.7418 C 11.7459 30.3643 11.6233 30.9807 11.3851 31.5557 C 11.1469 32.1308 10.7978 32.6533 10.3576 33.0935 C 9.91748 33.5336 9.39496 33.8827 8.81989 34.1209 C 8.24482 34.3591 7.62846 34.4817 7.00601 34.4817 C 6.38356 34.4817 5.7672 34.3591 5.19213 34.1209 C 4.61706 33.8827 4.09454 33.5336 3.6544 33.0935 C 3.21426 32.6533 2.86512 32.1308 2.62692 31.5557 C 2.38871 30.9807 2.26611 30.3643 2.26611 29.7418 L 7.00601 29.7418 L 11.7459 29.7418 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 10.33 12.63)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 1.57997,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(106,177,51)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-30.55, -31.94)",
    d: "M 25.9201 29.6307 C 25.9201 30.2385 26.0398 30.8403 26.2724 31.4018 C 26.5049 31.9633 26.8458 32.4735 27.2756 32.9032 C 27.7054 33.333 28.2156 33.6739 28.7771 33.9065 C 29.3386 34.1391 29.9404 34.2588 30.5482 34.2588 C 31.1559 34.2588 31.7578 34.1391 32.3193 33.9065 C 32.8808 33.6739 33.391 33.333 33.8207 32.9032 C 34.2505 32.4735 34.5914 31.9633 34.824 31.4018 C 35.0566 30.8403 35.1763 30.2385 35.1763 29.6307 L 30.5482 29.6307 L 25.9201 29.6307 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 10.12 7.9)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 1.57997,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(106,177,51)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-30.34, -27.22)",
    d: "M 36.2354 30.561 C 36.6717 30.561 37.0302 30.2061 36.9788 29.7728 C 36.8028 28.2902 36.1338 26.9005 35.0674 25.834 C 33.8137 24.5803 32.1133 23.876 30.3403 23.876 C 28.5673 23.876 26.867 24.5803 25.6133 25.834 C 24.5468 26.9005 23.8779 28.2902 23.7019 29.7728 C 23.6504 30.2061 24.009 30.561 24.4453 30.561 L 30.3403 30.561 L 36.2354 30.561 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -14.07 7.91)",
    id: "Ellipse 1872"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 0.789983,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(106,177,51)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-6.15, -27.22)",
    d: "M 2.23731 26.1133 C 3.34417 25.0064 4.82109 24.3547 6.37725 24.2785 C 6.46506 24.2742 6.56033 24.3099 6.63712 24.3867 L 11.7422 29.4917 C 11.991 29.7406 11.8148 30.166 11.4629 30.166 L 6.68504 30.166 L 0.789983 30.166 C 0.557433 30.166 0.419038 29.9862 0.438841 29.8194 C 0.604444 28.4243 1.23386 27.1167 2.23731 26.1133 Z",
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvGreen);
export default __webpack_public_path__ + "static/media/ev-green.bc897b72.svg";
export { ForwardRef as ReactComponent };